import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import CredentialsOverviewForm from './OverviewComponents/CredentialsOverviewForm';
import PersonalInformationDisclaimerAlert from '../../Notifications/PersonalInformationDisclaimerAlert';
import {
    getClinicianFlags,
    postClinicianFlags,
    patchClinicianFlags,
} from '../../../../services/Credentialing';
import WithContexts from '../../../../contexts/withContexts';
import UserContext from '../../../../contexts/userContext';

const styles = (theme) => ({
    pagePadding: {
        paddingBottom: '50px',
    },
});

export class CredentialsOverview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openAlert: true,
            clinicianFlags: {},
            isObjectEmpty: null,
        };
    }

    async componentDidMount() {
        const { externalId } = this.props.UserContext;
        const { setCredAppError } = this.props;
        let clinicianFlags = await getClinicianFlags(externalId).catch((e) => {
            setCredAppError(e);
        });
        // let isEmpty = false;
        if (!clinicianFlags) {
            // isEmpty = true;
            clinicianFlags = {};
        }

        // this.setState({ "clinicianFlags": clinicianFlags, isObjectEmpty: isEmpty })
    }

    toggleSignInAlert = async (isViewable, alertChecked) => {
        const state = this.state.clinicianFlags;
        const { externalId } = this.props.UserContext;
        const { setCredAppError } = this.props;
        if (alertChecked) {
            if (!this.state.isObjectEmpty) {
                state.flags.personalInfoDisclaimerFlag = alertChecked;
                await patchClinicianFlags(state, externalId).catch((e) => {
                    setCredAppError(e);
                });
            }
            if (this.state.isObjectEmpty) {
                const newObject = {
                    flags: {
                        personalInfoDisclaimerFlag: alertChecked,
                    },
                    clinicianExternalId: externalId,
                };
                await postClinicianFlags(newObject, externalId).catch((e) => {
                    setCredAppError(e);
                });
            }
        }
        localStorage.setItem('LocalStorage_PersonalInfoDisclaimerAlert', 'true');
        this.setState({ clinicianFlags: state, openAlert: isViewable });
    };

    renderDisclaimerAlert = () => {
        if (this.state.isObjectEmpty !== null) {
            if (
                (!this.state.clinicianFlags.flags ||
                    !this.state.clinicianFlags.flags.personalInfoDisclaimerFlag) &&
                !localStorage.getItem('LocalStorage_PersonalInfoDisclaimerAlert')
            ) {
                return (
                    <PersonalInformationDisclaimerAlert
                        toggleHandler={this.toggleSignInAlert}
                        openDialog={this.state.openAlert}
                    />
                );
            }
        }

        return null;
    };

    render() {
        const { classes, activePath, setCredAppError, clinician } = this.props;
        return (
            <div className={classes.pagePadding}>
                <CredentialsOverviewForm
                    activePath={activePath}
                    setCredAppError={setCredAppError}
                    clinician={clinician}
                />
            </div>
        );
    }
}
CredentialsOverview.contextType = UserContext;
export default WithContexts(withStyles(styles)(CredentialsOverview));
